(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/models/single-receiver.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/models/single-receiver.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.models.SingleReceiver = Backbone.Model.extend({
    defaults: {},

    initialize: function() {
      var self = this;
      if (svs.grassroots.data && svs.grassroots.data.singleReceiver) {
        self.set(svs.grassroots.data.singleReceiver);
        self.checkForMyReceivers();
      } else {
        self.fetch({
          error: function(model, response) {
            svs.grassroots_logger.error('Error fetching single receiver from jupiter: ' +
                self.url +
                ', response: ' +
                JSON.stringify(response));
          },
          success: function() {
            self.checkForMyReceivers();
          }
        });
      }
      self.listenTo(
        svs.grassroots.collections.my_receivers,
        'remove',
        function() {
          self.checkForMyReceivers();
        }
      );
      self.listenTo(svs.grassroots.collections.my_receivers, 'add', function() {
        self.checkForMyReceivers();
      });
      self.listenTo(
        svs.grassroots.collections.my_receivers,
        'reset',
        function() {
          self.checkForMyReceivers();
        }
      );
    },
    parse: function(response) {
      return response.receivers;
    },

    checkForMyReceivers: function() {
      this.set('myReceiver', false);
      var that = this;
      _.find(svs.grassroots.collections.my_receivers.models, function(model) {
        if (model.get('id') === that.get('id')) {
          that.set('myReceiver', true);
          return true;
        }
        return false;
      });
    }
  });
})(Backbone, _, svs);


 })(window);